// ----------------------------------------------------------------------
// <copyright file="Izenda.FloatAffixed.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * FloatAffixed component
 */
!(function() {
  var React = require('react');
  var observer = require('mobx-react').observer;
  var classnames = require('classnames');

  var domHelperEvents = require('dom-helpers/events');
  var FloatAffixedController = require('./Izenda.FloatAffixedController');
  var Portal = require('./Izenda.Portal');

  var FloatAffixed = React.createClass({
    propTypes: {
      children: React.PropTypes.oneOfType([
        React.PropTypes.element,
        React.PropTypes.array
      ]).isRequired,
      anchor: React.PropTypes.object.isRequired,
      edges: React.PropTypes.string,
      renderInContainer: React.PropTypes.bool,
      onClickOutside: React.PropTypes.func,
      onParentScroll: React.PropTypes.func,
      autoWidth: React.PropTypes.bool,
      minWidth: React.PropTypes.oneOfType([
        React.PropTypes.number,
        React.PropTypes.string
      ]),
    },

    getDefaultProps: function () {
      return {
        minWidth: 160,
        renderInContainer: true
      };
    },

    componentWillMount: function () {
      var props = this.props;

      this.anchor = props.anchor;
      this.controller = props.floatAffixedController || new FloatAffixedController();
    },

    componentDidMount: function() {
      this.eventWithAnchorAncestors(function(e) {
        domHelperEvents.on(e, "scroll", this.handleElementScroll);
      }.bind(this));
      domHelperEvents.on(window, 'resize', this.handleWindowResize);
      domHelperEvents.on(window, 'mousedown', this.handleDocumentClick);
      domHelperEvents.on(window, 'touchend', this.handleDocumentClick);

      this.controller.reposition(this.props, this.popup);
    },

    componentWillUnmount: function() {
      this.eventWithAnchorAncestors(function(e) {
        domHelperEvents.off(e, "scroll", this.handleElementScroll);
      }.bind(this));
      domHelperEvents.off(window, 'resize', this.handleWindowResize);
      domHelperEvents.off(window, 'mousedown', this.handleDocumentClick);
      domHelperEvents.off(window, 'touchend', this.handleDocumentClick);
    },

    componentWillReceiveProps: function(nextProps) {
      if (nextProps != this.props) {
        this.controller.reposition(nextProps, this.popup);
      }
    },

    handleDocumentClick: function(event) {
      var isInsidePopup = this.popup.contains(event.target) || (this.popup === event.target);
      var isInsideAnchor = this.anchor.contains(event.target) || (this.anchor === event.target);

      if (!isInsidePopup && !isInsideAnchor && !hasClass(event.target, "izenda")) {
        this.props.onClickOutside && this.props.onClickOutside(event);
      }

      function hasClass(element, cls) {
        return element.className && new RegExp("(\\s|^)" + cls + "(\\s|$)").test(element.className);
      }
    },

    eventWithAnchorAncestors: function(fn) {
      if (this.anchor) {
        var element = this.anchor.parentNode;
        while (element !== null && element !== window) {
          fn(element);
          element = element.parentNode;
        }
      }
    },

    handleElementScroll: function(event) {
      this.controller.reposition(this.props, this.popup);
      this.props.onParentScroll && this.props.onParentScroll(event);
    },

    handleWindowResize: function() {
      this.controller.reposition(this.props, this.popup);
    },

    refPopup: function(node) {
      this.popup = node;
    },

    render: function() {
      var props = this.props;
      var popupStyle = {
        left: this.controller.translation.x,
        top: this.controller.translation.y,
        width: this.anchor.offsetWidth
      };
      if (props.autoWidth) {
        popupStyle.width = (this.anchor.offsetWidth > props.minWidth) ? this.anchor.offsetWidth : props.minWidth;
      }

      var popupClasses = classnames({
        'izenda-FloatAffixed': true,
        'invisible': !this.controller.isElementInView(this.anchor, this.anchor.offsetParent)
      }, props.className, this.controller.schemeName);

      return props.renderInContainer
        ? <Portal>
            <div ref={this.refPopup} style={popupStyle} className={popupClasses}>{props.children}</div>
          </Portal>
        : <div ref={this.refPopup} style={popupStyle} className={popupClasses}>{props.children}</div>;
    }
  });

  module.exports = observer(FloatAffixed);
}());


// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.FloatAffixed.jsx